import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  isFunction, isArray, mapValues, keyBy, chain, isEmpty,
} from 'lodash';
import {
  ADD_PERMISSION,
  GET_PERMISSION,
  PUT_PERMISSION,
  GET_ROLES,
  POST_ACTION,
  GET_ACTION,
  DELETE_ACTION,
  GET_ROLE_INFO_BY_ID,
  POST_PERMISSION_CONTROL_FOR_ROLE,
  DELETE_PERMISSION,
  DELETE_ROLE,
  ADD_ROLE,
} from '../actions/authorization/action_types';
import actions from '../actions/authorization';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';

// saga effect

function* fetchAddPermission(action) {
  try {
    const res = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchPermission(action.params.data));
    if (res.data.message === 'Succeed') {
      utils.showNotification('Successfully!', 'You changed successfully!');
    }
    const data = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetPermissions());
    yield put(actions.getPermissionSucceed(data.data, data.total_count));
  } catch (err) {
    utils.showNotification('Lỗi', 'Quyền này đã có', 'error');
  }
}

function* fetchGetPermission(action) {
  try {
    const {
      data,
      total_count,
    } = yield call(
      (params) => rf.getRequest('AuthorizationRequest')
        .fetchGetPermissions(params),
      action.params,
    );
    if (isFunction(action.callback)) {
      yield action.callback(data);
    }

    yield put(actions.getPermissionSucceed(data, total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchPutPermission(action) {
  try {
    const res = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchPutPermission(action.params));
    if (res.data.message === 'Succeed') {
      utils.showNotification('Thông báo!', 'Thành công!');
      if (isFunction(action.callback)) {
        action.callback();
      }
    }
  } catch (err) {
    yield action.callback();
    console.log('err', err);
  }
}

function* fetchGetRoles(action) {
  try {
    const {
      data,
      total_count,
    } = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetRole());
    yield put(actions.getRolesSucceed(data, total_count));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchPostRole(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AuthorizationRequest').fetchPostRole(params),
      { name: action.params.role_name });
    if (action.params.base_on !== 0) {
      yield fetchGetRoles();
      const { data: listPermCtl } = yield call((params) => rf.getRequest('AuthorizationRequest').fetchPermCtrlByRole(params),
        { roleId: action.params.base_on });

      const permissions = [];
      listPermCtl.permissions.forEach((item) => {
        const controls = {};
        item.controls.forEach((i) => {
          controls[i.id] = true;
        });
        if (!isEmpty(controls)) {
          permissions.push({
            controls,
            id: item.id,
          });
        }
      });

      yield call((params) => rf.getRequest('AuthorizationRequest').postPermissionControlForRole(params), {
        permissions,
        role_id: data.id,
      });
    }

    yield utils.showNotification('Thông báo', 'Thêm vai trò thành công');
  } catch (err) {
    console.log('err', err);
  } finally {
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  }
}

function* fetchPostActions(action) {
  try {
    const res = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchPostAction(action.params));
    if (res.data.message === 'Succeed') {
      utils.showNotification('Successfully!', 'You changed successfully!');
    }
    const data = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetAction());
    yield put(actions.getActionSucceed(data.data, data.total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchGetActions(action) {
  try {
    const {
      data,
      total_count: totalCount,
    } = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetAction());
    yield put(actions.getActionSucceed(data, totalCount));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchDeleteActions(action) {
  try {
    yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchDeleteAction(action.params));
    const data = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetAction());
    yield put(actions.getActionSucceed(data.data, data.total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchGetPermissionsControlsByRole(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AuthorizationRequest')
      .fetchPermCtrlByRole(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(chain(data.permissions)
        .keyBy('id')
        .value());
      // console.log(chain(data.permissions).keyBy("id").value())
    }
  } catch (err) {
    console.log('err', err);
  }
}

function* postPermissionsControlsForRole(action) {
  try {
    const res = yield call(
      (params) => rf
        .getRequest('AuthorizationRequest')
        .postPermissionControlForRole(params),
      action.params,
    );
    if (res.data.message === 'Succeed') {
      utils.showNotification('Successfully!', 'You changed successfully!');
    }
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchDeletePermissionSaga(action) {
  try {
    yield call(
      (params) => rf.getRequest('AuthorizationRequest')
        .fetchDeletePermission(params),
      action.params,
    );
    const data = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetPermissions());
    yield put(actions.getPermissionSucceed(data.data, data.total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchDeleteRolesSaga(action) {
  try {
    yield call(
      (params) => rf.getRequest('AuthorizationRequest')
        .fetchDeleteRole(params),
      action.params,
    );
    const data = yield call(() => rf.getRequest('AuthorizationRequest')
      .fetchGetRole());
    yield put(actions.getRolesSucceed(data.data, data.total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* watchAuthorization() {
  yield takeLatest(ADD_PERMISSION, fetchAddPermission);
  yield takeLatest(GET_PERMISSION, fetchGetPermission);
  yield takeLatest(PUT_PERMISSION, fetchPutPermission);
  yield takeLatest(GET_ROLES, fetchGetRoles);
  yield takeLatest(POST_ACTION, fetchPostActions);
  yield takeLatest(GET_ACTION, fetchGetActions);
  yield takeLatest(DELETE_ACTION, fetchDeleteActions);
  yield takeLatest(GET_ROLE_INFO_BY_ID, fetchGetPermissionsControlsByRole);
  yield takeLatest(POST_PERMISSION_CONTROL_FOR_ROLE, postPermissionsControlsForRole);
  yield takeLatest(DELETE_PERMISSION, fetchDeletePermissionSaga);
  yield takeLatest(DELETE_ROLE, fetchDeleteRolesSaga);
  yield takeLatest(ADD_ROLE, fetchPostRole);
}

export default function* rootSaga() {
  yield all([fork(watchAuthorization)]);
}
